export enum httpMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PUT = "PUT",
  OPTIONS = "OPTIONS",
}
